var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { BaseInput } from './base-input';
import { FormField } from './form-field';
export const Checkbox = forwardRef((_a, ref) => {
    var { label, error, description, className = '', width, labelClassName = '', containerClassName = '', isRequired = false } = _a, props = __rest(_a, ["label", "error", "description", "className", "width", "labelClassName", "containerClassName", "isRequired"]);
    const id = React.useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, orientation: 'horizontal', labelPosition: 'right', labelVariant: 'label', width: width, labelClassName: labelClassName, className: containerClassName, isRequired: isRequired, children: _jsx(BaseInput, Object.assign({ ref: ref, id: id, type: 'checkbox', hasError: !!error, className: `!h-4 !w-4 !rounded !accent-vjwAccent ${className}` }, props)) }));
});
Checkbox.displayName = 'Checkbox';
